module.exports = __webpack_public_path__ + "static/img/cultureBg.8adc196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/cultureBg.png
// module id = FSKP
// module chunks = 0